(function () {
    'use strict';

    angular.module("imApp").factory("ediSourceService", ['$ihttp', function ($ihttp) {
        let service = {
            getEdit: function (parms) {
                return $ihttp.post({
                    method: 979,
                    parameters: parms || {}
                });
            },
            listExternalTypes: function (parms) {
                return $ihttp.post({
                    method: 980,
                    parameters: parms || {}
                });
            },
            saveObj: function (edit) {
                return $ihttp.post({
                    method: 985,
                    parameters: edit
                });
            }
        };

        return service;
    }]);
})();
